module.exports = __webpack_public_path__ + "img/new-people-courier-bike.b9fcb80d.png";